var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-level-footer"},[_c('el-button',{attrs:{"dark":"","outline":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('FoodC_supplement_Return_wVpv')))]),_c('el-button',{class:{ 'is-disabled': !_vm.nextReady },attrs:{"type":"primary","disabled":_vm.disabled},on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.$t('确认')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }